import { Stack } from '@mui/material';
import { FC, useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import { IFormValues } from '../../types';
import { IOption } from '~/ui/components/inputs/Select/types';
import Input from '~/ui/components/inputs/Input';
import PatientList from '../PatientList';
import Select from '~/ui/components/inputs/Select';
import { IUserPatientDto } from '~/services/api/users/types';

interface IProps {
  healthManagerOptions: IOption[];
  selectedIds: number[];
  disabledIds: number[];
  patients: IUserPatientDto[];
  onSelect: (ids: number[]) => void;
}

const TargetManagerColumn: FC<IProps> = ({
  healthManagerOptions,
  selectedIds,
  disabledIds,
  patients,
  onSelect,
}) => {
  const {
    control,
    register,
    watch,
    formState: { errors },
  } = useFormContext<IFormValues>();

  const [search, targetUserId, initialTargetIds, targetPatients] = watch([
    'targetSearch',
    'targetUserId',
    'initialTargetIds',
    'targetPatients',
  ]);

  const filtered = useMemo(
    () => patients.filter(p => p.fullName.toLowerCase().includes(search.toLowerCase())),
    [patients, search],
  );

  const isListChanged = useMemo(() => {
    if (!targetUserId) {
      return false;
    }

    if (targetPatients.length !== initialTargetIds.length) {
      return true;
    }

    const currentIds = targetPatients.map(x => x.id);

    return !initialTargetIds.every(x => currentIds.includes(x));
  }, [targetPatients, initialTargetIds, targetUserId]);

  return (
    <Stack spacing={2}>
      <Select
        name="targetUserId"
        control={control}
        errors={errors}
        options={healthManagerOptions}
        label="Health Manager"
        isDisabled={isListChanged}
      />
      <Input register={register} name="targetSearch" label="Search Patients" errors={errors} />
      <PatientList
        patients={filtered}
        selectedIds={selectedIds}
        disabledIds={disabledIds}
        isTargetEmpty={!targetUserId}
        onToggle={id =>
          onSelect(
            selectedIds.includes(id) ? selectedIds.filter(x => x !== id) : [...selectedIds, id],
          )
        }
      />
    </Stack>
  );
};

export default TargetManagerColumn;
